<div class="info-block" [class.info-block__center]="isCentered">
  <ng-container *ngIf="(isMobile$ | async) || (isTablet$ | async); else desktop">
    <img
      [src]="infoBlockConfig.img.src | imaginarySrc: 1:imgWidth"
      [srcset]="infoBlockConfig.img.src | imaginarySrc: 4:imgWidth"
      class="info-block__illustration"
      *ngIf="isCover"
      [class.info-block__illustration__cover]="isCover"
      alt=""
      loading="lazy"
    />
    <div class="info-block__content" [class.info-block__content__center]="isCentered">
      <img
        [src]="infoBlockConfig.img.src | imaginarySrc: 1:imgWidth"
        [srcset]="infoBlockConfig.img.src | imaginarySrc: 4:imgWidth"
        class="info-block__illustration"
        *ngIf="isCentered"
        alt=""
        loading="lazy"
      />
      <h2 class="info-block__title">
        <span class="line-break">{{ infoBlockConfig.title.main }}</span>
        <span class="highlight--emphasis" *ngIf="infoBlockConfig.title.emphasis">{{
          infoBlockConfig.title.emphasis
        }}</span>
      </h2>
      <ng-container
        *ngTemplateOutlet="
          blockContentOutlet;
          context: {
            showDetails: withExpansionPanel,
            showContent: withExpansionPanel ? (detailsAreOpen$ | async) : true
          }
        "
      >
      </ng-container>
    </div>
  </ng-container>
  <ng-container [ngSwitch]="infoBlockConfig.button.type">
    <ng-container *ngSwitchCase="InfoBlockLinkType.ROUTE">
      <a
        [id]="elm_id"
        class="btn-clean btn mentoring-employer-info__btn"
        [routerLink]="infoBlockConfig.button.link"
        [attr.aria-label]="infoBlockConfig.button.ariaLabel"
        (click)="trackerEvent()"
        >{{ infoBlockConfig.button.text }}
        <mat-icon
          *ngIf="infoBlockConfig.button.icon"
          class="info-block__btn__icon"
          [svgIcon]="infoBlockConfig.button.icon"
          role="presentation"
        ></mat-icon>
      </a>
    </ng-container>
    <ng-container *ngSwitchCase="InfoBlockLinkType.HREF">
      <a
        [id]="elm_id"
        class="btn-clean btn mentoring-employer-info__btn"
        [href]="infoBlockConfig.button.link"
        target="_blank"
        aria-label="infoBlockConfig.button.ariaLabel"
        (click)="trackerEvent()"
        >{{ infoBlockConfig.button.text }}
        <mat-icon
          *ngIf="infoBlockConfig.button.icon"
          class="info-block__btn__icon"
          [svgIcon]="infoBlockConfig.button.icon"
          role="presentation"
        ></mat-icon>
      </a>
    </ng-container>
    <ng-container *ngSwitchCase="InfoBlockLinkType.ACTION">
      <button
        [id]="elm_id"
        class="btn-clean btn mentoring-employer-info__btn"
        aria-label="infoBlockConfig.button.ariaLabel"
        (click)="actionClicked.emit()"
      >
        {{ infoBlockConfig.button.text }}
        <mat-icon
          *ngIf="infoBlockConfig.button.icon"
          class="info-block__btn__icon"
          [svgIcon]="infoBlockConfig.button.icon"
          role="presentation"
        ></mat-icon>
      </button>
    </ng-container>
  </ng-container>
</div>

<ng-template #desktop>
  <h2 class="info-block__title">
    <span class="line-break">{{ infoBlockConfig.title.main }}</span>
    <span class="highlight--emphasis" *ngIf="infoBlockConfig.title.emphasis">{{ infoBlockConfig.title.emphasis }}</span>
  </h2>

  <div
    class="info-block__content"
    [class.info-block__content__center]="isCentered"
    [class.info-block__content__cover]="isCover"
  >
    <img
      [src]="infoBlockConfig.img.src | imaginarySrc: 1:imgWidth"
      [srcset]="infoBlockConfig.img.src | imaginarySrc: 4:imgWidth"
      alt=""
    />
    <ng-container *ngTemplateOutlet="blockContentOutlet; context: { withDetails: false, showContent: true }">
    </ng-container>
  </div>
</ng-template>

<ng-template #blockContentOutlet let-showDetails="showDetails" let-showContent="showContent">
  <button
    class="btn-clean info-block__details-button"
    type="button"
    *ngIf="showDetails"
    (click)="toggleDetails()"
    [attr.ariaLabel]="showContent ? 'Cacher les détails' : 'Afficher les détails'"
  >
    Détails
    <mat-icon
      class="btn-clean info-block__details-button__icon"
      [class.info-block__details-button__icon--opened]="showContent"
      svgIcon="chevron_down"
      role="presentation"
    ></mat-icon>
  </button>
  <ng-content *ngIf="showContent"></ng-content>
</ng-template>
